import script from "./kefu.vue?vue&type=script&setup=true&lang=js"
export * from "./kefu.vue?vue&type=script&setup=true&lang=js"

import "./kefu.vue?vue&type=style&index=0&id=7bc83700&scoped=true&lang=css"

import exportComponent from "D:\\liu\\jmzc\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bc83700"]])

export default __exports__